<template lang="pug">
  div.lmm-content-body-padded(:class="{ 'is-mobile': isMobile }")
    b-container(fluid)
      //.btn-sec(v-if="user.member_type_id === 3")
      //  b-btn(size="sm" @click="showRegistForm = !showRegistForm") 등록
      b-row
        b-col(cols="12")
          b-card.w-100(no-body)
            b-list-group(flush)
              b-list-group-item(v-for="item in items", :key="item.pk")
                div.d-flex.w-100.justify-content-between
                  div.mb-1 {{item.notice_title}}
                  small {{item.notice_date | moment("from", "now")}}
                div.notice-body.mb-1.mt-2
                  p.notice-context(v-html="item.notice_content", :class="{readmore: item.readmore}")
                div
                  b-button(
                    size="sm",
                    variant="link",
                    v-if="!item.readmore",
                    :to="{name: 'notice-detail', params: {pk: item.pk}}") read more ...
    regist-form(:show.sync="showRegistForm" @close="showRegistForm = false" @complete="complete")
</template>

<script>
import { NoticeAPI } from "../../api"
import { store } from "@/api/store"
import RegistForm from "./regist"
import { user } from "@/api/access"

export default {
  name: "notice-component",
  components: {
    RegistForm,
  },
  computed: {
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
  },
  mounted() {
    this.user = user()
    this.notices().then(resp => (this.items = resp))
    window.LMM_MOBILE_CHECK = () => {
      this.AppState.isApplication = true
      store.set("LMM_MOBILE_APPLICATION", true)
    }
  },
  data() {
    return {
      user: {
        member_type_id: null,
      },
      showRegistForm: false,
      items: [],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 15, text: "15" },
          { value: 20, text: "20" },
        ],
      },
    }
  },
  methods: {
    setReadmore(item) {
      this.$log.info(`[SET READMORE '${item.notice_title}']`)
      item.readmore = true
    },
    notices() {
      let params = {
        by: "notice_date",
        limit: this.page.per,
        offset: (this.page.current - 1) * this.page.per,
        order: "desc",
        search_mode: "pagination",
        type: "ko",
      }
      return NoticeAPI.get("", { params }).then(resp => {
        return resp.data.objects
      })
    },
    complete() {
      this.showRegistForm = false
      this.notices().then(resp => (this.items = resp))
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-sec {
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 10px;
  padding-bottom: 10px;
  width: 100%;
  text-align: right;
}
.notice-body {
  padding: 5px 10px;
  border-top: 1px solid #ebebeb;

  .notice-context {
    color: #c7c7c7;
    white-space: pre-wrap;
    max-height: 38px;
    margin-bottom: 0;
    overflow: hidden;
  }
}
.is-mobile {
  small {
    white-space: nowrap;
  }
}
</style>
